module.exports = __webpack_public_path__ + "img/shape3.14897bbe.svg";